<pdr-headbar></pdr-headbar>
<div style="min-height: 58%;">
  <router-outlet></router-outlet>
</div>
<pdr-footbar></pdr-footbar>